import { Card, CardContent, Grid, Skeleton } from "@mui/material";
import styled from "styled-components";

const SkeletonWrapper = styled.div`
  margin-top:5%;
`;

const CardSkeleton = ({ height, repeat }) => {
    return (
        <Card variant="outlined">
            <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
                {Array.from({ length: repeat }).map((_, index) => (
                    <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }} key={index}>
                        <CardContent className="tile-cards">
                            <Skeleton
                                animation="wave"
                                variant="text"
                                sx={{ fontSize: 14 }}
                                width={100}
                                height={80}
                            />
                            <SkeletonWrapper>
                                <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    width={180}
                                    height={height}
                                />
                            </SkeletonWrapper>
                        </CardContent>
                    </Grid>
                ))}
            </Grid>
        </Card>
    );
};

const StatSkeleton = ({ tiles = 1, width = 2, height = 44, repeat = 1 }) => {
    return (
        <>
            {Array.from({ length: tiles }).map((_, index) => (
                <Grid size={{ xs: 2, sm: width, md: width, lg: width }} key={index}>
                    <CardSkeleton height={height} repeat={repeat} />
                </Grid>
            ))}
        </>
    );
};

export default StatSkeleton;